<script lang="ts">
    import {type DateRangeIntervalPartType, INFINITY_SYMBOL} from './types';
    import {createEventDispatcher} from 'svelte';
    import Loc from 'shared/components/kp-markdown/Loc.svelte';

    export let type: DateRangeIntervalPartType;
    export let selectedType: DateRangeIntervalPartType;
    export let isInfinity: boolean;

    $: selected = type === selectedType;

    const dispatch = createEventDispatcher<{
        'select': DateRangeIntervalPartType,
        'infinity': DateRangeIntervalPartType
    }>();

    const handleSelectClick = () => {
        dispatch('select', type);
    };

    const handleInfinityClick = () => {
        dispatch('infinity', type);
    };
</script>

<div class="interval-part-button">
    <button class="type-button" on:click={handleSelectClick} class:type-selected={selected}>
        {#if type === 'from'}
            <Loc code="commons.From"/>
        {:else if type === 'to'}
            <Loc code="commons.To"/>
        {/if}
    </button>

    <button class="infinity-button"
            on:click={handleInfinityClick}
            class:type-selected={isInfinity}>

        {INFINITY_SYMBOL}
    </button>
</div>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";
    @import (reference) "styles/portaro.variables.less";

    @btn-size: 30px;

    .interval-part-button {
        display: flex;
        height: @btn-size;
        outline: 1px solid @themed-border-default;
        border-radius: @border-radius-default;

        .type-button,
        .infinity-button {
            height: 100%;
            border: none;
            outline: none;
            cursor: pointer;
            background-color: @themed-body-bg;
            border-radius: @border-radius-default;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: background-color 0.3s ease-in-out;

            &:hover {
                background-color: @themed-body-bg-blue-highlighted;
            }

            &.type-selected {
                background-color: var(--accent-blue);
                color: white;

                &:hover {
                    background-color: #244394;
                }
            }
        }

        .type-button {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            border-right: 1px solid @themed-border-default;
        }

        .infinity-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            width: @btn-size;
        }
    }
</style>